"use client";

import { usePathname } from "next/navigation";

/**
 * Onde de choc qui jaillit du dock à chaque navigation. Le `key={pathname}`
 * force React à démonter/remonter l'élément à chaque changement de route :
 * l'animation CSS re-démarre depuis 0.
 *
 * Deux anneaux décalés pour effet "double ping" : un anneau principal
 * indigo + un anneau plus fin qui suit avec 180ms de delay.
 */
export function ShockwaveOverlay() {
  const pathname = usePathname();
  return (
    <div className="mf-shockwave-stage" aria-hidden="true">
      <div key={`p-${pathname}`} className="mf-shockwave mf-shockwave--primary" />
      <div key={`s-${pathname}`} className="mf-shockwave mf-shockwave--secondary" />
    </div>
  );
}
